const constant = (x) => () => x;

/**
 * Axis-aligned rectangle collision force. Assumes node.x/node.y are the
 * rect's top-left corner (consistent anchoring on both axes) and pushes
 * overlapping rects apart along whichever axis has the smaller penetration.
 */
export default function(width = 0, height = 0, strength = 1) {
  var nodes,
      widthAccessor = typeof width === "function" ? width : constant(width),
      heightAccessor = typeof height === "function" ? height : constant(height),
      strengthAccessor = typeof strength === "function" ? strength : constant(strength);

  function force(alpha) {
    for (var i = 0, n = nodes.length; i < n; ++i) {
      const a = nodes[i];
      const aw = widthAccessor(a), ah = heightAccessor(a);
      const acx = a.x + aw / 2, acy = a.y + ah / 2;

      for (var j = i + 1; j < n; ++j) {
        const b = nodes[j];
        const bw = widthAccessor(b), bh = heightAccessor(b);
        const bcx = b.x + bw / 2, bcy = b.y + bh / 2;

        const dx = bcx - acx;
        const dy = bcy - acy;
        const overlapX = (aw + bw) / 2 - Math.abs(dx);
        const overlapY = (ah + bh) / 2 - Math.abs(dy);

        if (overlapX <= 0 || overlapY <= 0) continue;

        const s = strengthAccessor(a, b) * alpha;

        // Separate along the axis with the smaller penetration.
        if (overlapX < overlapY) {
          const push = (overlapX / 2) * s * (dx === 0 ? (Math.random() - 0.5) : Math.sign(dx));
          a.vx -= push;
          b.vx += push;
        } else {
          const push = (overlapY / 2) * s * (dy === 0 ? (Math.random() - 0.5) : Math.sign(dy));
          a.vy -= push;
          b.vy += push;
        }
      }
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.width = function(_) {
    return arguments.length ? (widthAccessor = typeof _ === "function" ? _ : constant(+_), force) : widthAccessor;
  };

  force.height = function(_) {
    return arguments.length ? (heightAccessor = typeof _ === "function" ? _ : constant(+_), force) : heightAccessor;
  };

  force.strength = function(_) {
    return arguments.length ? (strengthAccessor = typeof _ === "function" ? _ : constant(+_), force) : strengthAccessor;
  };

  return force;
}
